export const IMAGE_MAP = {
  // SVG Images - Placeholder Images
  "interface-testing": "interface-testing.svg",
  "update-sync-2": "update-sync-2.svg",
  "page-not-found-2": "page-not-found-2.svg",
  "lab-experiment": "lab-experiment.svg",
  "listening-music-2": "listening-music-2.svg",
  "business-sharks": "business-sharks.svg",
  "online-shopping": "online-shopping.svg",
  families: "families.svg",
  "team-brainstorming": "team-brainstorming.svg",
  "facetime-meeting": "facetime-meeting.svg",
  "fingers-id-1": "fingers-id-1.svg",
  teamwork: "teamwork.svg",
  "work-in-progress": "work-in-progress.svg",
  "page-not-found": "page-not-found.svg",
  "smart-home-contol": "smart-home-contol.svg",
  "unknown-caller": "unknown-caller.svg",
  "smart-wearables": "smart-wearables.svg",
  "whistling-with-good-mood": "whistling-with-good-mood.svg",
  "listening-music-1": "listening-music-1.svg",
  "being-silly-crazy": "being-silly-crazy.svg",
  "work-in-progress-1": "work-in-progress-1.svg",
  "becoming-rich": "becoming-rich.svg",
  "beta-testing": "beta-testing.svg",
  "designer-giving-a-keynote": "designer-giving-a-keynote.svg",
  "listening-music": "listening-music.svg",
  "smart-phone": "smart-phone.svg",
  "free-shipping": "free-shipping.svg",
  strategy: "strategy.svg",
  "people-rushing": "people-rushing.svg",
  searching: "searching.svg",
  "product-launch": "product-launch.svg",
  certificate: "certificate.svg",
  "live-broadcast": "live-broadcast.svg",
  "online-learning": "online-learning.svg",
  "airdrop-plane-or-drone-dropping-coins":
    "airdrop-plane-or-drone-dropping-coins.svg",
  subscribe: "subscribe.svg",
  park: "park.svg",
  "cryptowallets-showing-different-types-of-cryptocurrencies":
    "cryptowallets-showing-different-types-of-cryptocurrencies.svg",
  "online-gifting": "online-gifting.svg",
  "team-brainstorming-1": "team-brainstorming-1.svg",
  leadership: "leadership.svg",
  "no-smoking": "no-smoking.svg",
  dna: "dna.svg",
  "chasing-money": "chasing-money.svg",
  "something-went-wrong": "something-went-wrong.svg",
  clickbait: "clickbait.svg",
  trophy: "trophy.svg",
  "inspire-others": "inspire-others.svg",
  "work-from-home": "work-from-home.svg",
  "we-got-a-problem": "we-got-a-problem.svg",
  "enter-password": "enter-password.svg",
  "business-trip": "business-trip.svg",
  coding: "coding.svg",
  "ecology-1": "ecology-1.svg",
  "design-thinking": "design-thinking.svg",
  rating: "rating.svg",
  "infrastructures-buildings": "infrastructures-buildings.svg",
  "asking-question": "asking-question.svg",
  selfie: "selfie.svg",
  "motivate-someone": "motivate-someone.svg",
  "cardless-withdrawal": "cardless-withdrawal.svg",
  "team-building": "team-building.svg",
  "modular-coding": "modular-coding.svg",
  "cruise-ship": "cruise-ship.svg",
  "training-employees": "training-employees.svg",
  "customize-product": "customize-product.svg",
  "human-right": "human-right.svg",
  "wash-hands": "wash-hands.svg",
  advertising: "advertising.svg",
  "saving-money": "saving-money.svg",
  "a-b-testing": "a-b-testing.svg",
  faq: "faq.svg",
  "message-sent": "message-sent.svg",
  "no-messages": "no-messages.svg",
  "no-email": "no-email.svg",
  "abandoned-cart": "abandoned-cart.svg",
  "graduation-1": "graduation-1.svg",
  "listening-to-feedback": "listening-to-feedback.svg",
  "getting-on-train": "getting-on-train.svg",
  "designing-a-website": "designing-a-website.svg",
  graduation: "graduation.svg",
  "high-five": "high-five.svg",
  "doing-sports": "doing-sports.svg",
  delete: "delete.svg",
  startup: "startup.svg",
  success: "success.svg",
  "identity-theft": "identity-theft.svg",
  "social-media-discussion": "social-media-discussion.svg",
  "order-completed": "order-completed.svg",
  "speacial-day-promo": "speacial-day-promo.svg",
  "ride-e-scooter": "ride-e-scooter.svg",
  ecology: "ecology.svg",
  "modular-coding-1": "modular-coding-1.svg",
  "logging-in": "logging-in.svg",
  "mask-uses": "mask-uses.svg",
  done: "done.svg",
  wildfire: "wildfire.svg",
  "fingers-id": "fingers-id.svg",
  "meditation-yoga": "meditation-yoga.svg",
  "fast-food": "fast-food.svg",
  "listening-to-feedback-1": "listening-to-feedback-1.svg",
  "being-vip": "being-vip.svg",
  "reading-a-book": "reading-a-book.svg",
  "404-not-found": "404-not-found.svg",
  "yoga-relax": "yoga-relax.svg",
  "cat-food": "cat-food.svg",
  "searching-looking": "searching-looking.svg",
  "certificate-item": "certificate-item.svg",
  travels: "travels.svg",
  // PNG - Background Images
  "bg-green-1": "bg-green-1.png",
  "bg-green-2": "bg-green-2.png",
  "bg-green-3": "bg-green-3.png",
  "bg-green-4": "bg-green-4.png",
  "bg-green-5": "bg-green-5.png",
  "bg-green-6": "bg-green-6.png",
  "bg-green-7": "bg-green-7.png",
  "bg-green-8": "bg-green-8.png",
  "bg-green-9": "bg-green-9.png",
  "bg-golden-1": "bg-golden-1.png",
  "bg-golden-2": "bg-golden-2.png",
  "bg-golden-3": "bg-golden-3.png",
  "bg-golden-4": "bg-golden-4.png",
  "bg-golden-5": "bg-golden-5.png",
  "bg-golden-6": "bg-golden-6.png",
  "bg-golden-7": "bg-golden-7.png",
  "bg-golden-8": "bg-golden-8.png",
  "bg-golden-9": "bg-golden-9.png",
  "bg-purple-1": "bg-purple-1.png",
  "bg-purple-2": "bg-purple-2.png",
  "bg-purple-3": "bg-purple-3.png",
  "bg-purple-4": "bg-purple-4.png",
  "bg-purple-5": "bg-purple-5.png",
  "bg-purple-6": "bg-purple-6.png",
  "bg-purple-7": "bg-purple-7.png",
  "bg-purple-8": "bg-purple-8.png",
  "bg-purple-9": "bg-purple-9.png",
  "bg-golden-v2-1": "bg-golden-v2-1.png",
  "bg-golden-v2-2": "bg-golden-v2-2.png",
  "bg-golden-v2-3": "bg-golden-v2-3.png",
  "bg-golden-v2-4": "bg-golden-v2-4.png",
  "bg-golden-v2-5": "bg-golden-v2-5.png",
  "bg-golden-v2-6": "bg-golden-v2-6.png",
  "bg-golden-v2-7": "bg-golden-v2-7.png",
  "bg-golden-v2-8": "bg-golden-v2-8.png",
  "bg-golden-v2-9": "bg-golden-v2-9.png",
  // PATTERN PALETTE IMAGES
  "pattern-palette-blue-theme_decorative":
    "pattern-palette-blue-theme_decorative.svg",
  "pattern-palette-blue-theme_ants": "pattern-palette-blue-theme_ants.svg",
  "pattern-palette-blue-theme_waves": "pattern-palette-blue-theme_waves.svg",
  "pattern-palette-blue-theme_math": "pattern-palette-blue-theme_math.svg",
  "pattern-palette-blue-theme_microbes":
    "pattern-palette-blue-theme_microbes.svg",
  "pattern-palette-blue-theme_maze": "pattern-palette-blue-theme_maze.svg",
  "pattern-palette-blue-theme_city": "pattern-palette-blue-theme_city.svg",
  "pattern-palette-blue-theme_topo": "pattern-palette-blue-theme_topo.svg",
  "pattern-palette-blue-theme_party": "pattern-palette-blue-theme_party.svg",
  "pattern-palette-blue-theme_notebook":
    "pattern-palette-blue-theme_notebook.svg",
  "pattern-palette-colorful-deep_decorative":
    "pattern-palette-colorful-deep_decorative.svg",
  "pattern-palette-colorful-deep_ants":
    "pattern-palette-colorful-deep_ants.svg",
  "pattern-palette-colorful-deep_waves":
    "pattern-palette-colorful-deep_waves.svg",
  "pattern-palette-colorful-deep_math":
    "pattern-palette-colorful-deep_math.svg",
  "pattern-palette-colorful-deep_microbes":
    "pattern-palette-colorful-deep_microbes.svg",
  "pattern-palette-colorful-deep_maze":
    "pattern-palette-colorful-deep_maze.svg",
  "pattern-palette-colorful-deep_city":
    "pattern-palette-colorful-deep_city.svg",
  "pattern-palette-colorful-deep_topo":
    "pattern-palette-colorful-deep_topo.svg",
  "pattern-palette-colorful-deep_party":
    "pattern-palette-colorful-deep_party.svg",
  "pattern-palette-colorful-deep_notebook":
    "pattern-palette-colorful-deep_notebook.svg",
  "pattern-palette-colorful_decorative":
    "pattern-palette-colorful_decorative.svg",
  "pattern-palette-colorful_ants": "pattern-palette-colorful_ants.svg",
  "pattern-palette-colorful_waves": "pattern-palette-colorful_waves.svg",
  "pattern-palette-colorful_math": "pattern-palette-colorful_math.svg",
  "pattern-palette-colorful_microbes": "pattern-palette-colorful_microbes.svg",
  "pattern-palette-colorful_maze": "pattern-palette-colorful_maze.svg",
  "pattern-palette-colorful_city": "pattern-palette-colorful_city.svg",
  "pattern-palette-colorful_topo": "pattern-palette-colorful_topo.svg",
  "pattern-palette-colorful_party": "pattern-palette-colorful_party.svg",
  "pattern-palette-colorful_notebook": "pattern-palette-colorful_notebook.svg",
  // LOGO
  "knoot-logo-black": "knoot-logo-black.png",
  "knoot-logo-white": "knoot-logo-white.png",
  "knoot-logo-bg-transparent-svg": "knoot-logo-bg-transparent.svg",
  "knoot-logo-bg-transparent-png": "knoot-logo-bg-transparent-2.png",
  // EMPTY STATE
  no_notifications: "no_notifications.svg",
  no_credit_cards: "no_credit_cards.svg",
  no_audio: "no_audio.svg",
  not_logging: "not_logging.svg",
  no_saving: "no_saving.svg",
  no_trash: "no_trash.svg",
  no_task: "no_task.svg",
  no_template: "no_template.svg",
  no_favorite_item: "no_favorite_item.svg",
  no_network: "no_network.svg",
  no_image: "no_image.svg",
  no_asset: "no_asset.svg",
  no_dashboard: "no_dashboard.svg",
  no_messages: "no_messages.svg",
  no_event: "no_event.svg",
  no_result: "no_result.svg",
  no_playlist: "no_playlist.svg",
  no_data: "no_data.svg",
  no_conversation: "no_conversation.svg",
  no_location_found: "no_location_found.svg",
  no_product: "no_product.svg",
  no_call_record: "no_call_record.svg",
  no_bank_connected: "no_bank_connected.svg",
  no_wallet: "no_wallet.svg",
};

export type ImageKey = keyof typeof IMAGE_MAP;
